import { Box } from "@mui/material";
import NavItem from "./NavItem";
import {
  GridViewRounded as MenuItem0,
  GroupAddRounded as MenuItem1,
  Groups2Rounded as MenuItem2,
  BrandingWatermarkSharp as MenuItem3,
  CategoryRounded as MenuItem4,
  SpeakerRounded as MenuItem5,
  InventoryRounded as MenuItem6,
  DvrRounded as MenuItem7,
  DiscountRounded as MenuItem8,
  ReceiptLongRounded as MenuItem9,
  AlignVerticalCenterRounded as MenuItem10,
  DescriptionRounded as MenuItem12,
  RateReviewRounded as MenuItem13,
  LogoutRounded as MenuItem11,
} from "@mui/icons-material";
import { useResetAuthDataState } from "lib/states/authState";

const icons = {
  MenuItem0,
  MenuItem1,
  MenuItem2,
  MenuItem3,
  MenuItem4,
  MenuItem5,
  MenuItem6,
  MenuItem7,
  MenuItem8,
  MenuItem9,
  MenuItem10,
  MenuItem11,
  MenuItem12,
  MenuItem13,
};

const items = [
  {
    id: 0,
    title: "Dashboard",
    url: "/",
    type: "link",
    icon: icons.MenuItem0,
  },
  {
    id: 1,
    title: "Users",
    url: "/users",
    type: "link",
    icon: icons.MenuItem1,
  },
  {
    id: 2,
    title: "Dealers",
    url: "/dealers",
    type: "link",
    icon: icons.MenuItem2,
  },
  {
    id: 3,
    title: "Brands",
    url: "/brands",
    type: "link",
    icon: icons.MenuItem3,
  },
  {
    id: 4,
    title: "Categories",
    url: "/categories",
    type: "link",
    icon: icons.MenuItem4,
  },
  {
    id: 5,
    title: "Products",
    url: "/products",
    type: "link",
    icon: icons.MenuItem5,
  },
  {
    id: 6,
    title: "Bundles",
    url: "/bundles",
    type: "link",
    icon: icons.MenuItem6,
  },
  {
    id: 7,
    title: "Orders",
    url: "/orders",
    type: "link",
    icon: icons.MenuItem7,
  },
  {
    id: 13,
    title: "Review Collection",
    url: "/reviews",
    type: "link",
    icon: icons.MenuItem13,
  },
  {
    id: 8,
    title: "Promo Codes",
    url: "/promo-codes",
    type: "link",
    icon: icons.MenuItem8,
  },
  {
    id: 9,
    title: "Upload Images",
    url: "/upload",
    type: "link",
    icon: icons.MenuItem9,
  },
  {
    id: 12,
    title: "Invoicing",
    url: "/invoicing",
    type: "link",
    icon: icons.MenuItem12,
  },
  // {
  //   id: 9,
  //   title: "Reports",
  //   url: "/reports",
  //   icon: icons.MenuItem8,
  // },
  // {
  //   id: 9,
  //   title: "Graphs",
  //   url: "/graphs",
  //   icon: icons.MenuItem9,
  // },
];

const Navigation = () => {
  const logout = useResetAuthDataState();
  const navLinks = items.map((item) => {
    return <NavItem key={item.id} item={item} />;
  });

  return (
    <Box sx={{ px: 2, height: "calc(100% - 80px)", overflowY: "auto" }}>
      {navLinks}
      <Box
        sx={{
          position: "absolute",
          bottom: 12,
          width: "calc(100% - 32px)",
        }}
      >
        <NavItem
          item={{
            title: "Logout",
            type: "button",
            icon: icons.MenuItem11,
            onClick: () => {
              logout();
            },
          }}
        />
      </Box>
    </Box>
  );
};

export default Navigation;
